interface SortArrowProps {
  status: number
}

function SortArrow({ status }: SortArrowProps) {
  const arrow = (dispStatus: number) => {
    switch (dispStatus) {
      case 0:
        return <span className='material-icons text-blue-500 hover:opacity-50 opacity-0'>arrow_drop_down</span>
      case 1:
        return <span className='material-icons text-red-500'>arrow_drop_up</span>
      case -1:
        return <span className='material-icons text-blue-500'>arrow_drop_down</span>
      case 9:
        return <span className='material-icons opacity-0'>arrow_drop_down</span>
      default:
        return null
    }
  }
  return <>{arrow(status)}</>
}

export default SortArrow
